import { render, staticRenderFns } from "./AddStudents.vue?vue&type=template&id=061f4102&"
import script from "./AddStudents.vue?vue&type=script&lang=js&"
export * from "./AddStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports